var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 text-right pt-6"},[_c('button',{staticClass:"btn btn-outline-success",attrs:{"type":"button","disabled":_vm.validator || _vm.sending},on:{"click":_vm.confirm}},[_c('i',{staticClass:"feather icon-save mr-3"}),_vm._v(_vm._s(_vm.buttonTitle)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }